/**
 * CDN path of a qset asset, relative to `CDN_URL`; the first two characters
 * of the hash are its directory. Shared by the fetch (`useGetPoll`) and the
 * feedback report's `Qset JSON:` line, so both name the same file.
 */
export const pollAssetPath = (assetHash: string): string =>
  `/${assetHash.slice(0, 2)}/${assetHash}`;
